import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class MismatchError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, description, additionalData) {
    super(reportService, description, 'MISMATCH_ERROR', 0, true, additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/MismatchError.ts